import React, { useState, useEffect } from 'react';
import CountrySelect from "./components/CountrySelect";
import CitySelect from "./components/CitySelect";
import OffersList from "./components/OffersList";
import DepartmentSelect from "./components/DepartmentSelect";
import axios from 'axios';
import './App.scss';
import CategorySelect from "./components/CategorySelect";

const App = () => {
    const [source, setSource] = useState([]);
    const [currentCountry, setCurrentCountry] = useState(0);
    const [currentCity, setCurrentCity] = useState(0);
    const [currentDepartment, setCurrentDepartment] = useState(0);
    const [currentCategory, setCurrentCategory] = useState(0);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(5);

    useEffect(() => {
        const fetchSource = async () => {
            setLoading(true);
            const res = await axios.get(document.getElementById('offers_list').dataset.source);
            setSource(res.data);
            setLoading(false);
        };
        fetchSource();
    }, []);

    const setCountry = (id) => {
        setCurrentCountry(parseInt(id));
        setCurrentCity(0);
        setCurrentPage(1);
    };

    const setCity = (id) => {
        setCurrentCity(parseInt(id));
        setCurrentPage(1);
    }

    const setDepartment = (id) => {
        setCurrentDepartment(id);
        setCurrentPage(1);
    }

    const setCategory = (id) => {
        setCurrentCategory(id);
        setCurrentPage(1);
    }

    const paginate = (data) => {
        setCurrentPage(data.selected+1);
    };

    if (loading) {
        return (
            <div className="cr_container">
                <div className="cr_filters">
                    <div className="lds-ripple">
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="cr_container">
            <div className="cr_filters">
                <div className="cr_filters_options">
                    <div>
                        <CountrySelect source={source} setCountry={setCountry} />
                        <CitySelect source={source} country={currentCountry} setCity={setCity} />
                        <DepartmentSelect source={source} setDepartment={setDepartment} />
                        <CategorySelect source={source} setCategory={setCategory} />
                    </div>
                </div>
                {/*<input type="button" className="cr_filters_btn_search" value="Szukaj" />*/}
            </div>
            <OffersList source={source}
                        country={currentCountry}
                        city={currentCity}
                        department={currentDepartment}
                        category={currentCategory}
                        perPage={perPage}
                        paginate={paginate}
                        currentPage={currentPage}
            />
        </div>
    );
};

export default App;
